import { BACKEND_URL } from "../../global";
import keycloak from "../../keycloak";

function getAllChildren(childArray, fileMap) {
    let newChildArray = [];
    childArray.map((each) => {
        if (fileMap[each].isDir) {
            newChildArray.push(getAllChildren(fileMap[each].childrenIds, fileMap));
        } else {
            newChildArray.push(fileMap[each]);
        }
    });
    return newChildArray.flat(Infinity);
}

export async function deleteFiles(files, folderChain, fileMap) {
    try {
        var newFileMap = { ...fileMap };
        var newFolderChain = [...folderChain]
        // Loop backwards to avoid index shifting
        for (const [key, value] of Object.entries(newFileMap)) {
            if (files.includes(value.id)) {
                if (value.isDir) {
                    //File is existing folder
                    getAllChildren([value.id], fileMap).map(each => {
                        fetch(BACKEND_URL + '/asr_results/' + each.interview_id,
                            {
                                method: 'DELETE',
                                headers: {
                                    Authorization: `Bearer ${keycloak.token}`
                                }
                            });
                        delete newFileMap[each.id];
                    });
                    delete newFileMap[value.id]
                } else {
                    fetch(BACKEND_URL + '/asr_results/' + value.interview_id, {
                        method: 'DELETE',
                        headers: {
                            Authorization: `Bearer ${keycloak.token}`
                        }
                    });
                    delete newFileMap[value.id];
                }
                // Update the parent folder to make sure it doesn't try to load the
                // file we just deleted.
                if (value.parentId) {
                    const parent = newFileMap[value.parentId];
                    const newChildrenIds = parent.childrenIds.filter(
                        (id) => id !== value.id
                    );
                    newFileMap[value.parentId] = {
                        ...parent,
                        childrenIds: newChildrenIds,
                        childrenCount: newChildrenIds.length,
                    };
                    //Update folderChain's last element
                    if (value.parentId == newFolderChain[newFolderChain.length - 1].id) {
                        newFolderChain[newFolderChain.length - 1] = newFileMap[value.parentId]
                    }
                }
            }
        }
        let returnData = { fileMap: newFileMap, folderChain: newFolderChain }
        return returnData
    } catch (error) {
        console.error("Error posting data:", error);
        return null;
    }
}

export default deleteFiles;